<template>
  <div class="qingsu-train-item">
    <div class="training-list-wrap">
      <div class="header">
        <div class="label">{{ label }}</div>
        {{ title }}
      </div>
      <ul class="training-desc">
        <li v-for="(v, index) in slicedTrainings" :key="index" class="training">
          <div class="tr-line">
            <div class="tr-line-top"></div>
            <div class="tr-line-bottom"></div>
          </div>
          <div class="tr-time">{{ v.time }}</div>
          <div class="tr-content">{{ v.training_name || v.name }}</div>
        </li>
      </ul>
    </div>
    <div v-if="trainings.length > 3" @click="handleFold">
      <p class="unfold-btn" v-if="folded">
        查看剩余{{ trainings.length - 3 }}段培训
      </p>
      <p class="unfold-btn" v-else>收起</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    trainings: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: '培训'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      folded: true
    }
  },
  computed: {
    slicedTrainings() {
      return this.folded ? this.trainings.slice(0, 3) : this.trainings
    }
  },
  methods: {
    handleFold() {
      this.folded = !this.folded
      this.$emit('toggle', this.folded)
    }
  }
}
</script>

<style lang="scss" scoped>
.qingsu-train-item {
  .training-desc {
    font-size: 28px;
    text-align: justify;
    line-height: 48px;
    color: #566171;
    padding-left: 74px;
  }
  .training-list-wrap {
    margin-top: 34px;
    .header {
      display: flex;
      align-items: center;
      font-size: 22px;
      font-weight: 500;
      color: #21252d;
      line-height: 26px;
      margin-bottom: 28px;
    }
    .label {
      font-size: 16px;
      font-weight: 500;
      color: #ff745b;
      line-height: 16px;
      padding: 6px 8px;
      background: #fff1e2;
      margin-right: 16px;
      border-radius: 4px;
    }
  }

  $pl: 28px;
  .unfold-btn {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ff745b;
    font-weight: 500;
    padding-left: $pl + 8;
    margin-top: 20px;
    text-align: center;
  }
  .training {
    padding-bottom: 40px;
    position: relative;
    &:last-of-type {
      padding-bottom: 0;
    }
    .tr-time {
      position: relative;
      color: #9da3ac !important;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // background-color: green;
      padding-left: $pl;
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(-7px, -50%);
        border-radius: 50%;
        width: 16px;
        height: 16px;
        background: #ff745b;
      }
    }
    .tr-content {
      color: #6c798c !important;
      line-height: 1.5 !important;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-top: 4px;
      padding-left: $pl;
    }
    .tr-line {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      display: flex;
      flex-direction: column;
      opacity: 0.4;
      .tr-line-top {
        width: 100%;
        height: 28px;
        border-left: 1px dashed #ff745b !important;
      }
      .tr-line-bottom {
        width: 100%;
        height: 28px;
        flex: 1;
        border-left: 1px dashed #ff745b !important;
      }
    }
    &:first-of-type .tr-line-top {
      border-left: 1px dashed transparent !important;
    }
    &:last-of-type .tr-line-bottom {
      border-left: 1px dashed transparent !important;
    }
  }
}
</style>
